import React from "react";
import T from "prop-types";
import { fromJS } from "immutable";
import { Col } from "react-bootstrap";
import { AuditFields } from "MODULES/shared/components";
import ReleaseDetails from "MODULES/SalesOrders/components/Detail/Panel/ReleaseDetails/ReleaseDetails";
import Details from "./Details";
import Billing from "./Billing";
import ShipTo from "./ShipTo";
import ReturnTo from "./ReturnTo";
import Consignment from "./Consignment";

export default function Panel({ salesOrder }) {
  return (
    <Col md={3}>
      <div className="panel panel-default">
        <div className="panel-body">
          <Details />
          <ReleaseDetails salesOrder={salesOrder} />
          <Consignment />
          <hr />
          <Billing />
          <hr />
          <ShipTo />
          <hr />
          <div>
            <ReturnTo />
          </div>
          <AuditFields record={fromJS(salesOrder)} multiLine />
        </div>
      </div>
    </Col>
  );
}

Panel.propTypes = {
  salesOrder: T.shape({}).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Panel.jsx